// extracted by mini-css-extract-plugin
module.exports = {"wrap":"project-event_wrap_2uD02"};